import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "type",
    type: "translate",
    sortable: true,
    searchable: true,
  },
  {
    name: "credit_limit",
    type: "money",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="policies" columns={columns} />;
}
